import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "vi-table" }



import { ElTable } from "element-plus";
import { ElTableColumn } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'vi-table',
  props: {
    data: {},
    columns: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElTable), {
      data: props.data,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (column) => {
          return (_openBlock(), _createBlock(_unref(ElTableColumn), {
            key: column.label,
            prop: column.accessor,
            label: column.label
          }, null, 8, ["prop", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})